import '../../css/GenericBuilder/AppointmentSchdule.css';
import React, { useEffect, useState, useContext } from "react";
import PropTypes from 'prop-types';
import { GlobalContext } from '../utils/GlobalContext';
import { CONSTANT } from '../utils/constants';
import CaptchaInput from '../utils/CaptchaInput';
import axios from 'axios';

const AppointmentSchedule = ({handlePagesChanges}) => {
    const [captchaData, setCaptchaData] = useState({ value: '', token: '', expires_at: 0 });
    const [captchaRefreshTrigger, setCaptchaRefreshTrigger] = useState(0);
    const [captchaError, setCaptchaError] = useState("");
    const [toast, setToast] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);

    const showToast = (message, type) => setToast({ message, type });

    useEffect(() => {
        if (!toast.message) return;
        const timer = setTimeout(() => {
            setToast({ message: '', type: '' });
            if (toast.type === 'success') handleGoBack();
        }, 3000);
        return () => clearTimeout(timer);
    }, [toast.message, toast.type]);
    const { client_code, selectedItemId, category, builderType } = useContext(GlobalContext);
    const [ formData, setFormData ] = useState({
        style_number:"",
        customer_name:"",
        customer_email:"",
        zip:"",
        phone:"",
        notes:"",
        selectContactName:"Email",
        store_location:"",
    });

    const [storeLocations, setStoreLocations] = useState([]);

    useEffect(() => {
        if (!client_code) return;
        axios.post(`${CONSTANT.BASE_URL}api/Builder/get-store-locations`, { account_number: client_code })
            .then(res => setStoreLocations(res.data.locations || []))
            .catch(() => setStoreLocations([]));
    }, [client_code]);

    const reloadCaptcha = () => {
        setCaptchaData({ value: '', token: '', expires_at: 0 });
        setCaptchaRefreshTrigger(n => n + 1);
        setCaptchaError('');
    };

    const verifyCaptcha = async () => {
        try {
            const response = await axios.post(`${CONSTANT.BASE_URL}api/Builder/verifyCaptcha`, {
                answer: captchaData.value,
                token: captchaData.token,
                expires_at: captchaData.expires_at,
            });
            return response.data.success === true;
        } catch (err) {
            return false;
        }
    };

    /**
     * Reset form
     */
    const handleReset = () => {
        setFormData({
            style_number: selectedItemId?.itemDetails?.product_code || "",
            customer_name: "",
            customer_email: "",
            zip: "",
            phone: "",
            notes: "",
            selectContactName: "",
            store_location: "",
        });
        reloadCaptcha();
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!captchaData.token) {
            setCaptchaError("Please complete the captcha verification.");
            return;
        }

        const isCaptchaValid = await verifyCaptcha();
        if (!isCaptchaValid) {
            setCaptchaError("Incorrect answer. Please try again.");
            reloadCaptcha();
            return;
        }

        setCaptchaError('');
        setIsLoading(true);

        const base_url = `${CONSTANT.BASE_URL}api/Builder/schedule-appointment`;

        try {
            const response = await axios.post(base_url, {
                form_control: `Yes`,
                style_number: formData.style_number,
                customer_name: formData.customer_name,
                customer_email: formData.customer_email,
                zip: formData.zip,
                phone: formData.phone,
                notes: formData.notes,
                selectContactName: formData.selectContactName,
                store_location: formData.store_location,
                account_number: client_code,
                category: category,
                itemDetails: selectedItemId['itemDetails'],
            });

            if (response.data.status) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'private_showing_submit',
                    form_name: 'private_showing',
                    lead_source: category === 'Bangle Builder' ? 'bangle_builder' : 'Ring Builder',
                    builder_type: builderType,
                    style_number: formData.style_number,
                    price: selectedItemId?.price,
                    customer_number: client_code,
                    retailer_domain: window.location.hostname,
                });
                handleReset();
                showToast("Your appointment request has been submitted successfully!", 'success');
            } else {
                showToast(response.data.message || "Error sending the email. Please contact the admin team.", 'error');
                reloadCaptcha();
            }
        } catch (error) {
            console.error("Error submitting form:", error);

            if (error.response?.status === 422) {
                const errors = error.response.data.errors;
                if (errors) {
                    showToast(Object.values(errors).flat().join(', '), 'error');
                } else {
                    showToast(error.response.data.message || "Validation failed.", 'error');
                }
            } else {
                showToast("Error submitting the form. Please try again.", 'error');
            }
            reloadCaptcha();
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleContactName = (event) => {
        const { value } = event.target; // Extract the selected value
        console.log();
        setFormData((prevData) => ({ 
            ...prevData, 
            selectContactName: value // Update the selectContactName field in the formData state
        }));
    }

    const handleGoBack = () => {
        // Logic for going back
        handlePagesChanges('Main','Complete');
    };

    useEffect(() => {
        console.log("Selected Item ID:", selectedItemId);
        console.log(client_code);
    },[selectedItemId, client_code]);
    useEffect(() => {
        if (!selectedItemId?.itemDetails) return;
        const excludedKeys = ['itemDetails', 'stones'];
        const notesLines = [];

        // Add product name
        if (selectedItemId?.itemDetails?.product_code) {
            setFormData((prevData) => ({
                ...prevData,
                style_number: selectedItemId.itemDetails.product_code
            }));
        }

        // Add dynamic key-value pairs (like "Metal Type Base: 14K")
        Object.entries(selectedItemId).forEach(([key, value]) => {
            if (
                !excludedKeys.includes(key) &&
                typeof value === 'string' &&
                value.trim()
            ) {
                notesLines.push(`${key}: ${value}`);
            }
        });

        // Add stones, if available
        if (Array.isArray(selectedItemId.stones)) {
            selectedItemId.stones.forEach((stone, index) => {
                if (stone.stone_name) {
                    notesLines.push(`Stone ${index + 1}: ${stone.stone_name}`);
                }
            });
        }

        setFormData((prevData) => ({
            ...prevData,
            notes: notesLines.map(line => `• ${line}`).join('\n'),
        }));
    }, [selectedItemId]);

    const toastStyles = {
        position: 'fixed',
        top: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        minWidth: '300px',
        maxWidth: '480px',
        padding: '16px 20px',
        borderRadius: '8px',
        boxShadow: '0 6px 24px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '15px',
        fontWeight: '500',
        color: '#fff',
        backgroundColor: toast.type === 'success' ? '#28a745' : '#dc3545',
        animation: 'fadeInDown 0.3s ease',
    };

    return (
        <>
          {toast.message && (
            <div style={toastStyles}>
              <span style={{ fontSize: '20px' }}>{toast.type === 'success' ? '✔' : '✖'}</span>
              <span style={{ flex: 1 }}>{toast.message}</span>
              <button onClick={() => setToast({ message: '', type: '' })} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '18px', cursor: 'pointer', lineHeight: 1 }}>×</button>
              {toast.type === 'success' && (
                <div style={{ position: 'absolute', bottom: 0, left: 0, height: '3px', backgroundColor: 'rgba(255,255,255,0.5)', borderRadius: '0 0 8px 8px', animation: 'shrink 3s linear forwards' }} />
              )}
            </div>
          )}
          <style>{`
            @keyframes fadeInDown {
              from { opacity: 0; transform: translateX(-50%) translateY(-16px); }
              to   { opacity: 1; transform: translateX(-50%) translateY(0); }
            }
            @keyframes shrink {
              from { width: 100%; }
              to   { width: 0%; }
            }
          `}</style>
                <div className="appointment-schdule" style={{margin:`auto`,justifyItems:`center`}}>
                    <div className="from-loader" style={{ textAlign: "center", width:`80%` }}>
                        <div className="d-flex justify-content-center">
                            <div className="sk-circle sk-primary">
                                {/* Add CSS loader dots here */}
                            </div>
                        </div>
                    </div>
                    <div id="frombody" className="appointment-frombody">
                        <h1 style={{textAlign:`center`}}>REQUEST A PRIVATE SHOWING</h1>
                        <form onSubmit={handleFormSubmit} id="frmShowing">
                            {/* Style Number */}
                            <div className='row' style={{padding:'5px'}}> 
                                <div className="col-12 col-sm-12 col-lg-12" style={{textAlign:`right`}}>
                                    <span className="errmsg-appointment">*</span> Required Fields
                                </div>
                                <div className='col-12 col-sm-12 col-lg-12 errmsg-appointment'></div>
                            </div>
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label><span className="errmsg-appointment">*</span>Style #:</label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <input type="text"  name="style_number" value={formData.style_number} onChange={handleChange} readOnly className="form-control" />
                                </div>
                            </div>
                            {/* Name */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Name :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <input type="text" name="customer_name" className="form-control" placeholder="Name :" value={formData.customer_name} onChange={handleChange} required />
                                </div>
                            </div>
                            {/* Email */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>E-mail :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <input type="email" name="customer_email" className="form-control" placeholder="E-mail :" value={formData.customer_email}  onChange={handleChange} required />
                                </div>
                            </div>
                            {/* Zip */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Zip :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <input type="text" name="zip" className="form-control" placeholder="Zip :" value={formData.zip} onChange={handleChange} required />
                                </div>
                            </div>
                            {/* Phone */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Phone :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <input type="text" name="phone" className="form-control" placeholder="Phone :" value={formData.phone} onChange={handleChange} required />
                                </div>
                            </div>
                            {/* Notes */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Notes :
                                    </label>
                                </div>
                                <div className="col-12 col-sm-8 col-md-9 col-lg-9">
                                    <textarea name="notes" className="form-control" placeholder="Notes" onChange={handleChange} value={formData.notes} required rows={14} ></textarea>
                                </div>
                            </div>
                            {/* Preferred contact option */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Preferred contact option :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    <select className="form-control"  value={formData.selectContactName}  onChange={handleContactName}  required >
                                        {["","Phone","Email"].map((contact_data) => (
                                            <option key={contact_data} value={contact_data}>{contact_data}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {/* Store Location */}
                            {storeLocations.length > 0 && (
                                <div className="row" style={{padding:'5px'}}>
                                    <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                        <label>
                                            <span className="errmsg-appointment">*</span>Select Store Location :
                                        </label>
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                        <select className="form-control" name="store_location" value={formData.store_location} onChange={handleChange} required>
                                            <option value="">Select Store Location</option>
                                            {storeLocations.map((location, index) => (
                                                <option key={index} value={location.email}>{location.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                            {/* Captcha */}
                            <div className="row" style={{padding:'5px'}}>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3">
                                    <label>
                                        <span className="errmsg-appointment">*</span>Verification Code :
                                    </label>
                                </div>
                                <div className="col-8 col-sm-8 col-md-9 col-lg-9">
                                    {/* CAPTCHA Component */}
                                    <CaptchaInput value={captchaData.value}
                                        onCaptchaChange={(data) => setCaptchaData(data)}
                                        onChange={(e) => setCaptchaData(prev => ({ ...prev, value: e.target.value }))}
                                        error={captchaError}
                                        onError={(msg) => setCaptchaError(msg)}
                                        refreshTrigger={captchaRefreshTrigger}
                                    />
                                </div>
                            </div>
                            {/* Agreement */}
                            {client_code == 'K200' && (
                                <div className="row" style={{padding:'5px'}}>
                                    <div className="col-12">
                                        <input type="checkbox" name="agree" value="agree" required />{" "}
                                        By selecting this, you agree to share your information with our retail partners.<span className="errmsg-appointment">*</span>
                                    </div>
                                </div>
                            )}
                            {/* Buttons */}
                            <div className="row" style={{padding:'5px',textAlign:`center`}}>
                                <div className="col-12">
                                <button type="button" style={{margin:'5px'}} className="btn btn-primary" onClick={handleGoBack} disabled={isLoading}>
                                    <i className="fa fa-arrow-left"></i> Back
                                </button>
                                <button type="submit" style={{margin:'5px'}} className="btn btn-primary" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight:'6px'}}></span>
                                            Submitting...
                                        </>
                                    ) : 'Submit'}
                                </button>
                                <button type="reset" style={{margin:'5px'}} className="btn btn-primary" disabled={isLoading}>
                                    ↻ Reset
                                </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
        </>
    );
};

AppointmentSchedule.propTypes = {
    clientDetails: PropTypes.object.isRequired,
    clientLayerDetails: PropTypes.object,
    handlePagesChanges: PropTypes.func.isRequired,
};

export default AppointmentSchedule;
